export const TranslationInfoCookieName = 'translations.showInfo';
export const TranslationInfoCookieValue = '1';
//# sourceMappingURL=translationsCookies.js.map